import React from "react";
import { FiGlobe, FiSmartphone, FiCpu, FiLayers } from "react-icons/fi";
import { LuSettings, LuShield, LuPercent, LuUsers, LuSmartphone, LuShieldCheck, LuPalette, LuCode, LuRocket, LuClipboardList, LuCircleCheck, LuSearch } from "react-icons/lu";

export const IosHeroData = {
  backgroundImage: "/images/serviceBanners/ioSApp.webp",
  whiteImage: "/images/serviceBanners/iOS AppBannerW.webp",
  subTitle: "iOS App Development Services",
  title: (
    <>
      Premium <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">iOS App Development </span>
      Solutions
    </>
  ),
  description:
    "We build high performance native iOS applications using Apple ecosystem technologies to deliver secure, smooth, and seamless user experiences across iPhone and iPad with scalable and reliable mobile solutions.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast and optimized iOS application performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Smooth UI experience across all Apple devices.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Built with Apple security standards for stability.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Maintainable and developer-friendly Swift code.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/icons/swift_icon.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(240,81,56,0.35)",
      iconGlow: "rgba(240,81,56,0.9)",
    },
  ],
};
// 2. Stats Block
export const iosStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const iosSolutionsAndProcessData = {
  buildSubtitle: "OUR SERVICES",
  buildTitle: "Custom iOS App Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform iOS Support",
      desc: "Build scalable apps optimized for Apple ecosystem and multi-device compatibility.",
      icon: FiSmartphone,
      colorClass: "text-[#F05138]",
      bgClass: "bg-[#F05138]/10",
      borderClass: "border-[#F05138]/20 hover:border-[#F05138]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(240,81,56,0.25)]",
    },
    {
      title: "Enterprise iOS Solutions",
      desc: "Develop secure and scalable mobile apps for large business operations.",
      icon: FiCpu,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce iOS Apps",
      desc: "Create smooth shopping experiences with secure payment integration.",
      icon: FiLayers,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand iOS Apps",
      desc: "Build real-time booking and service-based mobile applications.",
      icon: FiGlobe,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech iOS Solutions",
      desc: "Develop secure financial apps with modern user experience and compliance.",
      icon: FiSmartphone,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom iOS Development",
      desc: "Tailored iOS applications based on business goals and requirements.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "IOS APP DEVELOPMENT PROCESS",
  processTitle: "iOS App Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and iOS app requirements.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define features, architecture, and iOS development roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create intuitive and Apple-focused user interface designs.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Development",
      description: "Build scalable and high-performance iOS applications using Swift.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test performance, security, and compatibility across Apple devices.",
      icon: LuCircleCheck,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Publish on App Store and provide continuous maintenance and updates.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR IOS APP DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose iOS App Development Solutions",
  benefits: [
    "Cross-platform support",
    "Faster iOS development",
    "Modern UI design",
    "Smooth performance boost",
    "Efficient workflow system",
    "Scalable iOS solutions",
    "Cost-effective development",
  ],
  logoImage: "/images/serviceBanners/ioSApp.webp",
  whiteLogoImage: "/images/serviceBanners/iOS AppBannerW.webp",
};

// 4. Portfolio Block
export const iosPortfolioData = {
  subtitle: "OUR WORK",
  title: "iOS Apps Redefining Mobility",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "LuxRetail Pro",
      badge: "E-Commerce",
      badgeColor: "bg-[#F05138]/10 text-[#F05138] border-[#F05138]/20",
      desc: "A premium retail app with ARKit integration for virtual try-ons.",
      downloads: "500k+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/iOS-Custom.png",
    },
  ],
};

// 5. Technologies Block
export const iosTechnologiesData = {
  techTitle: "IOS TECH STACK",
  technologies: [
    { name: "Swift", icon: "Code" },
    { name: "SwiftUI", icon: "Vite" },
    { name: "Core Data", icon: "SQLite" },
    { name: "Combine", icon: "Zap" },
    { name: "Xcode", icon: "RestAPI" },
    { name: "TestFlight", icon: "Firebase" },
  ],
  trustTitle: "TRUSTED BY ENTERPRISES",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const iosAboutData = [
  {
    title: "iOS App Development Company for Premium Mobile Experiences",
    content: (
      <>
        Modern businesses need mobile applications that deliver smooth performance, strong security, and consistent user experiences across Apple devices. A trusted{" "}
        <b className="text-text-primary font-semibold">ios app development company</b> helps organizations create feature-rich applications designed to improve customer engagement
        and long-term business growth. Many businesses struggle with mobile apps that fail to meet user expectations around speed and usability. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, iOS applications are developed around business objectives, performance requirements, and customer
        behavior to help brands create reliable and future-ready digital experiences.
      </>
    ),
  },
  {
    title: "Custom iPhone App Development for Better User Engagement",
    content: (
      <>
        A successful mobile application depends on delivering seamless experiences that feel intuitive and reliable for users. Reliable{" "}
        <b className="text-text-primary font-semibold">custom iphone app development</b> helps businesses create personalized mobile solutions that improve customer satisfaction
        and support brand growth. Companies investing in <b className="text-text-primary font-semibold">ios mobile app development services</b> often benefit from better usability
        because applications are designed around real customer expectations and platform behavior. Tycho Technologies focuses on practical iOS strategies that improve performance
        while supporting long-term scalability and customer retention.
      </>
    ),
  },
  {
    title: "Hire iOS App Developers for Scalable Mobile Solutions",
    content: (
      <>
        Businesses looking to strengthen mobile experiences often require applications that remain flexible as customer needs evolve. Companies aiming to{" "}
        <b className="text-text-primary font-semibold">hire ios app developers</b> usually prioritize scalability, performance, and maintainability to support long-term success.
        Organizations expanding mobile ecosystems frequently combine development strategies with{" "}
        <a href="https://tychotechnologies.com/hybrid-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          hybrid app development company
        </a>{" "}
        solutions to improve flexibility and create stronger digital experiences across multiple platforms.
      </>
    ),
  },
  {
    title: "Why Businesses Choose an iOS App Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">ios app development company in india</b> continues to grow as businesses seek premium mobile
        experiences and stronger customer engagement. Companies investing in <b className="text-text-primary font-semibold">iphone app development services india</b> often focus on
        performance, usability, and secure mobile ecosystems. Businesses partnering with Tycho Technologies gain access to customized iOS frameworks designed around measurable
        business goals and user expectations. Many organizations also strengthen mobile growth strategies through{" "}
        <a href="https://tychotechnologies.com/android-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          android app development company
        </a>{" "}
        solutions to support wider digital accessibility and connected user experiences.
      </>
    ),
  },
];
export const iosAppFaqs = [
  {
    q: "Why should I hire iPhone app developers in India for my project?",
    a: "iPhone app developers in India offer skilled, cost-effective solutions for building high-quality iOS apps. They can create custom apps with smooth performance, attractive design, and seamless integration with Apple’s ecosystem, helping your business reach iPhone users globally.",
  },
  {
    q: "What can iPhone developers do for my business?",
    a: "iPhone developers specialize in designing and building apps for iOS devices. They handle app architecture, coding, testing, and deployment, ensuring your app is fast, secure, and user-friendly on iPhones and iPads.",
  },
];
